module.exports = __webpack_public_path__ + "media/customizations/onvie/back-c10306277a18050550df51f18a2226cf.jpg";